import { useEffect } from "react";
import { useToast } from "@/components/action-feedback";
import {
  startMonitoringProcessingPoll,
  stopMonitoringProcessingPoll,
} from "@/src/services/monitoring_processing_store";
import { useOnMonitoringProcessingFinished } from "./use-monitoring-processing";

export function MonitoringProcessingWatcher({
  enabled,
  intervalMs,
}: {
  enabled: boolean;
  intervalMs?: number;
}) {
  const showToast = useToast();

  useEffect(() => {
    if (!enabled) return;
    startMonitoringProcessingPoll(intervalMs);
    return () => stopMonitoringProcessingPoll();
  }, [enabled, intervalMs]);

  useOnMonitoringProcessingFinished(() => {
    showToast({
      tone: "success",
      text: "Entities processing in monitoring system has been completed.",
    });
  });

  return null;
}
